var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeroicon = function SvgHeroicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m8 0 .611.549c1.54 1.382 3.619 2.229 5.907 2.229h.11l.652-.008.203.587c.344.991.518 2.028.517 3.071 0 4.58-3.306 8.427-7.778 9.518L8 16l-.222-.054C3.306 14.856 0 11.009 0 6.428c0-1.071.181-2.104.517-3.071L.72 2.77l.652.007.11.001c2.288 0 4.366-.847 5.907-2.23zM2.033 4.45a7.8 7.8 0 0 0-.255 1.978c0 3.717 2.629 6.855 6.222 7.83 3.593-.975 6.222-4.113 6.222-7.83 0-.683-.088-1.346-.255-1.979A10.66 10.66 0 0 1 8 2.28a10.66 10.66 0 0 1-5.967 2.17",
    clipRule: "evenodd"
  })));
};
export default SvgHeroicon;